const Form044TC = {
    stepName: {
        personalInfo: "個人資料",
        kindergarten: "幼兒中心名稱",
        confirmation: "確認",
        signature: "簽署",
        importantNotes: "重要事項",
    },
    headerTitle: "教師/幼兒工作員資料表（{{schoolYear}} 學年）",
    errorMsg: {
        maxError: "最大長度為 ",
        characterType: "字符類型只允許 (英文 / 數字 / 中文)",
        alphabetsOnly: "字符類型只允許 (英文)",
        chineseOnly: "字符類型只允許 (中文)",
        numericOnly: " 字符類型只允許 (數字)",
        otherPost: "其他職位",
        no: "請最少填寫一個編號",
        uploadMax: "文件上傳限制為： ",
        checkPosition: "請確保校長及幼兒中心主管的信息分別至少有一個。",
        needOne: "必須填寫“幼稚園名稱”或“幼兒中心名稱”",
        schoolHead: "姓名",
        atLeastOneValidFirstAid: "申請時應至少填寫一份有效的急救證書編號",
        atLeastOneValidNo: "申請時應至少填寫一份有效編號",
        repeatNo:
            "檢定教員註冊編號和有效准用教員編號不應在同一條員工記錄中同時填寫",
    },

    schoolHeadOption: {
        supervisor: "校監",
        principal: "校長",
    },
    label: {
        statement: "本人已閱讀、明白及同意上述條款及細則。",
        iamSmartStatement:
            "本人理解申請人和學校審批人需要擁有「智方便+」帳戶才能處理申請。",
        kindergarten: "幼稚園名稱",
        childCareCentre: "幼兒中心名稱",
        basicInfor: "幼稚園及幼兒中心名稱",
        note: {
            noteTitle: "注意：",
            note1: "「BEd(ECE)」：持有幼兒教育學士學位或同等學歷的合格幼稚園教師/幼兒工作員",
            note2: "「C(ECE)」：持有幼兒教育證書或同等學歷的合格幼稚園教師/幼兒工作員",
            note3: "「QKT」：合格幼稚園教師",
            note4: "「CCW」：幼兒工作員",
            note5: "「Pursuing C(ECE)」：正在修讀幼兒教育證書或同等學歷的課程的合格幼稚園教師/幼兒工作員/持有檢定教員註冊編號/有效准用教員編號的敎師",
            note6: "請在適用方格打勾",
            note7: "除已呈交者外，請呈交所有教員證、幼兒工作員證及有效急救證書的核實副本存檔",
            note8: "申請必須包括校長及幼兒中心主管各1名或其他職位(請註明)",
            note9: "申請必須包括校長及幼兒中心主管各一名或其他職位(請註明)",
        },
        personalInfo: {
            teacherNameEn: "教師/幼兒工作員姓名(英文)",
            teacherNameCh: "教師/幼兒工作員姓名 (中文)",
            qualification: "資歷",
            rtptLabel: "檢定教員註冊編號 /有效准用教員編號",
            // rtptOption: {
            //     rtNo: "檢定教員註冊編號",
            //     validPTNo: "有效准用教員編號",
            // },
            rtNo: "檢定教員註冊編號",
            validPTNo: "有效准用教員編號",
            cccLabel: "幼兒中心主管/幼兒工作員註冊編號",
            // cccOption: {
            //     cccsNo: "幼兒中心主管註冊編號",
            //     cccwNo: "幼兒工作員註冊編號",
            // },
            cccsNo: "幼兒中心主管註冊編號",
            cccwNo: "幼兒工作員註冊編號",
            workingHours: "工作時間",
            appointment: "入職本校日期",
            post: "職位",
            otherPost: "請註明",
            classResponsible: "任職班別",
            firstAid: "曾接受急救訓練",
            certificateNo: "有效急救訓練證書編號(如適用)",
            certificateNoErrField: "有效急救訓練證書編號",
            aidCertificateNoValid: "急救訓練證書編號生效日期",
            aidCertificateNoExpiry: "急救訓練證書編號到期日期",
            aidCertificateAttachment: "急救訓練證書副本",

            signatureTitle: "簽署信息",
            schoolHead: "校監/校長",
            schoolHeadName: "姓名",
            upload: {
                uploadButton:
                    "除已呈交者外，請呈交所有教員證、幼兒工作員證及有效急救證書的核實副本存檔",
                // remark: {
                //     title: "備註:",
                //     content: "文件最大為 10MB",
                //     content2: "允許類型: pdf， jpg， jpeg，png， zip， rar",
                //     content3: "最大上傳限制: 1",
                // },
            },
            qualificationGP: {
                bed: "BEd(ECE)",
                c: "C(ECE)",
                qkt: "QKT",
                ccw: "CCW",
                pursuing: "Pursuing C(ECE)",
            },
            workingTime: {
                ap: "上午 + 下午",
                am: "上午",
                pm: "下午",
            },
            postGP: {
                principal: "校長",
                childCare: "幼兒中心主管",
                other: "其他，請註明（例如：教師、主任、幼兒中心工作員、副校長）：",
            },
            classGP: {
                kg: "幼稚園",
                ccc: "幼兒中心",
            },
            firstAidGP: {
                yes: "是",
                no: "否",
            },
        },
    },
    title: {
        title1: "個人資料收集聲明",
    },
    note: {
        note1: {
            title: `1.	你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：`,
            subtitle: "收集個人資料的目的",
            content1:
                "(a)	就教師 / 幼兒工作員資料表，辦理有關處理、核實及查證的事務；",
            content2:
                "(b)	就上文(a)項所述的處理、核實及查證，辦理有關把個人資料與政府相關政策局／部門資料庫進行核對程序的事務；",
            content3:
                "(c)	為核實／更新教育局的記錄，辦理有關把個人資料與教育局資料庫進行核對程序的事務；",
            content4:
                "(d)	辦理有關培訓及發展的事務，包括發出計劃／活動邀請、處理發還課程費用申請、 評審提名、獎項和獎學金，以及監察達標進度；",
            content5:
                "(e)	辦理有關處理及審核撥款／補助／津貼申請、發放撥款／補助／津貼，以及審計的事務；",
            content6: "(f)	辦理有關編製統計資料、研究材料及政府刊物的事務；以及",
            content7:
                "(g)	辦理有關施行及強制執行規則及規例[包括《教育條例》(香港法例第279章)及其附屬法例(例如《教育規例》、《補助學校公積金規則》、《津貼學校公積金規則》)和《資助則例》)]的事務；及《幼兒服務條例》(香港法例第243章)及其附屬法例 [(即《幼兒服務規例》(香港法例第243A章)]的事務",
        },
        note2: {
            title: `2.	你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理。`,
        },
        note3: {
            title: `3.	你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：`,
            subtitle: "可獲轉移資料者",
            content1: "(a)	政府其他政策局及部門，以用於上文第1段所述的用途；",
            content2: "(b)	與本表格相關的學校，以用於上文第1段所述的用途；",
            content3: "(c)	你曾就披露個人資料給予訂明同意；以及",
            content4:
                "(d)	根據適用於香港的法例或法庭命令授權或規定披露個人資料。",
        },
        note4: {
            title: `4.	你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向以下人士提出：香港太古城太古灣道14號6樓602室幼稚園及幼兒中心聯合辦事處當值主任或電郵至 <a href='mailto: jokc@edb.gov.hk'>jokc@edb.gov.hk</a>。`,
            subtitle: "查閱個人資料",
        },
    },
};
export default Form044TC;
